import { useState } from 'react'
import PhoneInput from 'react-phone-input-2'
import DatePicker from 'react-datepicker'
import Select from '../../../components/Select'
import {
  LISTED_STATE_OPTIONS_WITH_NON_US,
  NON_US_STATE_SELECT_VALUE,
  toStateSelectValue
} from '../../../utilities/usStateOptions'

import 'react-phone-input-2/lib/style.css'
import 'react-datepicker/dist/react-datepicker.css'

export default function ApplicationStep1({ handleApplicationStep1, finishedApplication }) {
  const [firstName, setFirstName] = useState('')
  const [lastName, setLastName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
  const [entityName, setEntityName] = useState('')
  const [entityState, setEntityState] = useState('')
  const [withPEO, setWithPEO] = useState('')
  const [remainingERCCredits, setRemainingERCCredits] = useState('')
  const [filedAfterDate, setFiledAfterDate] = useState('')
  const [quarters, setQuarters] = useState([])
  const [agreeToTerms, setAgreeToTerms] = useState(false)

  const validateEmail = (value) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
    return regex.test(value)
  }

  return (
    <div className='w-full px-4 sm:px-8 flex flex-col items-center'>
      <p className='font-bold text-lg p-4'>Let's get some basic information.</p>
      <div className='flex flex-col items-center w-full space-y-8'>
        <div className='w-full space-y-4'>
          <h2 className='text-base font-semibold'>Personal Information</h2>
          <div className='grid lg:grid-cols-2 gap-x-4 gap-y-4'>
            <div className='w-full relative'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>First Name</p>
              <input
                type='text'
                name='firstName'
                placeholder='John'
                value={firstName}
                onChange={(e) => setFirstName(e.target.value)}
                className='mt-1 p-3 w-full border rounded-md shadow-sm'
              />
            </div>
            <div className='w-full relative'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Last Name</p>
              <input
                type='text'
                name='lastName'
                placeholder='Doe'
                value={lastName}
                onChange={(e) => setLastName(e.target.value)}
                className='mt-1 p-3 w-full border rounded-md shadow-sm'
              />
            </div>
            <div className='w-full relative'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Email</p>
              <input
                type='email'
                name='email'
                placeholder='johndoe@example.com'
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className='mt-1 p-3 w-full border rounded-md shadow-sm'
              />
            </div>
          </div>
          <h2 className='text-base font-semibold pt-4'>(Phone)</h2>
          <div className='grid lg:grid-cols-2 gap-x-4 gap-y-4'>
            <div className='w-full relative'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Phone</p>
              <PhoneInput
                country={'us'}
                disableDropdown
                countryCodeEditable={false}
                value={phone}
                onChange={setPhone}
                inputProps={{
                  name: 'phone',
                  required: true,
                  className: 'p-3 w-full border rounded-md shadow-sm pl-12',
                }}
                containerClass='w-full'
              />
            </div>
          </div>
        </div>
        <div className='w-full space-y-4 border-t pt-6'>
          <h2 className='text-base font-semibold'>Entity Information</h2>
          <div className='grid lg:grid-cols-2 gap-x-4 gap-y-4'>
            <div className='w-full relative'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Entity Name</p>
              <input
                type='text'
                name='entityName'
                placeholder='My Entity'
                value={entityName}
                onChange={(e) => setEntityName(e.target.value)}
                className='mt-1 p-3 w-full border rounded-md shadow-sm'
              />
            </div>
            <div className='w-full relative'>
              <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Entity State</p>
              <Select
                name='entityState'
                value={toStateSelectValue(entityState)}
                onChange={(val) => setEntityState(val === NON_US_STATE_SELECT_VALUE ? '' : val)}
                searchable
                placeholder='Select a state...'
                options={LISTED_STATE_OPTIONS_WITH_NON_US}
              />
              {toStateSelectValue(entityState) === NON_US_STATE_SELECT_VALUE && (
                <div className='mt-3'>
                  <label htmlFor='application-step1-entity-state-other' className='block text-sm font-medium text-gray-700 dark:text-slate-300 mb-1'>
                    State / province / region
                  </label>
                  <input
                    id='application-step1-entity-state-other'
                    type='text'
                    value={entityState}
                    onChange={(e) => setEntityState(e.target.value)}
                    placeholder='e.g. Guam, Ontario, England'
                    className='mt-1 p-3 w-full border rounded-md shadow-sm'
                  />
                </div>
              )}
            </div>
          </div>
        </div>
        <div className='w-full space-y-4 border-t pt-6'>
          <h2 className='text-base font-semibold'>ERC Refund Amount</h2>
          <div className='w-full relative'>
            <p className='absolute text-sm bg-white left-3 top-[-5px] max-sm:text-[0.7rem] max-sm:top-[-4px]'>Approximate Total ERC Refund the IRS Still Owes You</p>
            <input
              type='text'
              inputMode='numeric'
              pattern='[0-9]*'
              placeholder='120000'
              value={remainingERCCredits}
              onChange={(e) => {
                const value = e.target.value
                if (/^\d*$/.test(value))
                  setRemainingERCCredits(value)
              }}
              className='mt-1 p-3 w-full border rounded-md shadow-sm'
            />
          </div>
        </div>
        <div className='w-full space-y-4 border-t pt-6'>
          <label className='text-base font-semibold'>Were you associated with a Professional Employer Organization (PEO) or third-party payer (e.g., ADP TotalSource, Insperity, Paychex, TriNet) for payroll/tax filing during ERC periods?</label>
          <div className='flex gap-6'>
            {['Yes', 'No'].map(option => (
              <label key={option} className='flex items-center gap-3 text-gray-800 cursor-pointer'
              >
                <input
                  type='radio'
                  name='withPEO'
                  value={option}
                  checked={withPEO === option}
                  onChange={() => setWithPEO(option)}
                  className='w-5 h-5 accent-blue-600'
                />
                <span className='text-base'>{option}</span>
              </label>
            ))}
          </div>
          {withPEO === 'Yes' && (
            <div className='space-y-2 bg-blue-50 p-4 rounded-md border border-blue-100'>
              <p className='font-bold text-lg'>What is a PEO?</p>
              <p className='text-gray-700'>A Professional Employer Organization provides HR, payroll, and compliance services and may file tax documents, including ERC claims, under its own EIN. You likely used a PEO if:</p>
              <ul className='list-disc list-inside space-y-1 text-gray-700'>
                <li>Payroll reports list a PEO.</li>
                <li>Form 941s or ERC filings show a different EIN.</li>
                <li>W-2s display a third-party employer.</li>
                <li>HR/payroll is managed externally. (If unsure, check with your payroll provider or accountant.)</li>
              </ul>
            </div>
          )}
        </div>
        <div className='w-full space-y-4 border-t pt-6'>
          <h2 className='text-base font-semibold'>ERC Filing Details</h2>

          <div className='space-y-4'>
            <label className='text-base font-semibold'>Did you file for your ERC refund after 1/31/24?</label>
            <div className='flex gap-6'>
              {['Yes', 'No'].map(option => (
                <label key={option} className='flex items-center gap-3 text-gray-800 cursor-pointer'>
                  <input
                    type='radio'
                    name='filedAfterDate'
                    value={option}
                    checked={filedAfterDate === option}
                    onChange={() => {
                      setFiledAfterDate(option)
                      if (option === 'No') setQuarters([])
                    }}
                    className='w-5 h-5 accent-blue-600'
                  />
                  <span className='text-base'>{option}</span>
                </label>
              ))}
            </div>
          </div>

          {filedAfterDate === 'Yes' && (
            <div className='space-y-4'>
              <label className='text-base font-semibold'>Which 2021 quarters are your ERC claims not paid? (Select all that apply)</label>
              <div className='flex gap-6'>
                {[
                  { key: 'q12021', label: 'Q1 2021 (Jan-Mar)' },
                  { key: 'q22021', label: 'Q2 2021 (Apr-Jun)' },
                  { key: 'q32021', label: 'Q3 2021 (Jul-Sep)' },
                  { key: 'q42021', label: 'Q4 2021 (Oct-Dec)' },
                ].map(option => (
                  <label key={option.key} className='flex items-center gap-2 text-gray-700'>
                    <input
                      type='checkbox'
                      name={option.key}
                      value={option.key}
                      checked={quarters.includes(option.key)}
                      onChange={() => {
                        if (quarters.includes(option.key))
                          setQuarters(quarters.filter(q => q !== option.key))
                        else
                          setQuarters((prevQuarters) => [...prevQuarters, option.key])
                      }}
                      className='w-4 h-4 accent-blue-600'
                    />
                    {option.label}
                  </label>
                ))}
              </div>
            </div>
          )}
        </div>
        <div className='w-full space-y-4 border-t pt-6'>
          <div onClick={() => setAgreeToTerms(!agreeToTerms)} className='flex flex-row gap-2 items-center cursor-pointer'>
            <input
              type='checkbox'
              checked={agreeToTerms}
              onChange={(e) => setAgreeToTerms(e.target.checked)}
            />
            <p>I agree to receive SMS updates about my tax refund application from ERTC Refund. Message & data rates may apply. Reply STOP to unsubscribe.</p>
          </div>
        </div>
        <button
          className={`px-8 py-3 text-white rounded-md ${finishedApplication || !firstName || !lastName || !email || !phone || !entityName || !String(entityState || '').trim() || !remainingERCCredits || !withPEO || !filedAfterDate || (filedAfterDate === 'Yes' && quarters.length === 0) || !validateEmail(email) || !agreeToTerms ? 'bg-gray-400 cursor-not-allowed' : 'bg-ertc-primary'}`}
          disabled={finishedApplication || !firstName || !lastName || !email || !phone || !entityName || !String(entityState || '').trim() || !remainingERCCredits || !withPEO || !filedAfterDate || (filedAfterDate === 'Yes' && quarters.length === 0) || !validateEmail(email) || !agreeToTerms}
          onClick={() => handleApplicationStep1(firstName, lastName, email, phone, entityName, entityState, remainingERCCredits, withPEO, filedAfterDate, quarters)}
        >
          Finish
        </button>
        {finishedApplication && (
          <div className='flex flex-row items-center justify-center gap-2'>
            <div className='loader ease-linear rounded-full border-[6px] border-t-[6px] border-gray-200 dark:border-slate-700 border-t-ertc-primary dark:border-t-ertc-primary h-8 w-8 animate-spin'></div>
            <p className='text-md text-center'>Submitting Application...</p>
          </div>
        )}
      </div>
    </div>
  )
}